<!--
  @component
  Generates an SVG y-axis. This component is also configured to detect if your y-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
<script>
	import { getContext } from "svelte";
	import TickY from "./TickY.svelte";

	const { padding, xRange, yScale, yDomain, yRange } = getContext("LayerCake");

	/** @type {Function} [formatTick=d => d] - A function that passes the current tick value and expects a nicely formatted value in return. */
	// export let formatTick;

	export let allYTicks;
	export let yTicks = [];
	export let xTicks;
	export let shouldAddSuffix;
</script>

<g class="axis y-axis" transform="translate({-$padding.left}, 0)">
	{#each allYTicks as tick, i (tick)}
		<TickY {tick} {xTicks} hidden={!yTicks.includes(tick)} suffix={shouldAddSuffix(tick) ? "Tsd." : undefined} />
	{/each}
</g>
